import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetHeaderCloseButton,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import styles from './ScopeChangeRequestFinalizedDialog.module.css'
import { byDesign } from '@/infra/design'
import imgWelcomeUrl from '@/assets/misc/img_welcome.svg'
import CreateTeamIllustration from '@/components/SpotIllustration/CreateTeamIllustration'

export interface ScopeChangeRequestFinalizedDialogProps {
  showing: boolean
  onClose: () => unknown
  corporateMode: boolean
  createdByName: string
  isClientApprovalRequired?: boolean
  clientName?: string
}

export function ScopeChangeRequestFinalizedDialog({
  showing,
  onClose,
  corporateMode,
  createdByName,
  isClientApprovalRequired,
  clientName,
}: ScopeChangeRequestFinalizedDialogProps) {
  return (
    <ModalSheet showing={showing} onRequestClose={onClose}>
      <ModalSheetHeader>
        <div className={styles.closeButtonContainer}>
          <ModalSheetHeaderCloseButton testId="scope-change-request-close-finalized-dialog" />
        </div>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={imgWelcomeUrl}
              illustration={byDesign(undefined, CreateTeamIllustration)}
              alt="Thank you for your response"
            />
          )}
          <ModalSheetContentTitle>
            Thank you for your response
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            You have accepted the job scope updates sent by{' '}
            <span className={styles.collaboratorName}>{createdByName}</span>
            {isClientApprovalRequired && (
              <>
                {' '}
                and will be shared with{' '}
                <span className={styles.collaboratorName}>
                  {clientName}
                </span>{' '}
                next for their approval
              </>
            )}
            .
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            onPress={onClose}
            variant="default"
            testId="scope-change-request-close-finalized"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
